const SCRIPT_CLOSE_REGEX = /<\/script>/gi;

export const arrayBufferToBase64 = (buffer) => {
  if (!buffer) {
    return '';
  }
  const bytes = new Uint8Array(buffer);
  let binary = '';
  const chunkSize = 0x8000;
  for (let i = 0; i < bytes.length; i += chunkSize) {
    const chunk = bytes.subarray(i, i + chunkSize);
    binary += String.fromCharCode.apply(null, chunk);
  }
  return btoa(binary);
};

export const escapeClosingScript = (text = '') => text.replace(SCRIPT_CLOSE_REGEX, '<\\/script>');
